import { render, staticRenderFns } from "./SalesContractOverview.vue?vue&type=template&id=3411de30&scoped=true"
import script from "./SalesContractOverview.vue?vue&type=script&lang=js"
export * from "./SalesContractOverview.vue?vue&type=script&lang=js"
import style0 from "@/assets/sass/dashboard.scss?vue&type=style&index=0&id=3411de30&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3411de30",
  null
  
)

export default component.exports